import React from 'react';
import {
  Formik,
  Form,
} from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import {
  initFormValues,
} from '~/commons/helpers';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import FieldFileSlider from '~/commons/components/FieldFileSlider.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const defaultCollapsible = {
  header: '',
  content: '',
};
const defaults = {
  title: '',
  description: '',
  coverImg: null,
  content: '',
  slider: [],
  collapsibles: [],
  list: [],
};

const FormViewSlot = ({
  viewSlot,
}) => {
  const [res, req] = useHttpStatus();
  const { format } = viewSlot;

  return (
    <Formik
      initialValues={initFormValues(defaults, viewSlot)}
      onSubmit={async (values, actions) => {
        const { status } = await req({
          method: 'patch',
          url: `api/site/view-slots/${viewSlot._id}`,
          data: {
            ...values,
            coverImg: typeof values.coverImg === 'string'
              ? values.coverImg : '',
            slider: values.slider.filter((s) => typeof s === 'string'),
          },
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}
    >
      <Form>
        <FormHttpSaveBtn
          res={res}
          className="btn-primary mb-3"
          disabled={false}
        />
        <FormHttpAlert res={res} />
        {format === 'slider' && (
          <>
            <FieldFileSlider
              name="slider"
              api={'api/site/view-slots/files'}
            />
          </>
        )}
        {(format === 'page' || format === 'slot') && (
          <>
            <FormGroup name="title" />
            {format === 'page' && (
              <>
                <FormGroup
                  name="description"
                  helpText="A short description of the page shown in search engines' results and social media"
                />
                <FormGroup
                  name="coverImg"
                  as="coverImg"
                  api={'api/site/view-slots/files'}
                />
              </>
            )}
            <FormGroup
              name="content"
              as="summernote"
              fileUploadUrl={'api/site/view-slots/files'}
            />
          </>
        )}
        {(format === 'page' || format === 'list') && (
          <div className="form-group">
            <label>List</label>
            <FieldArrayIterables
              name="list"
              push={defaultCollapsible}
            >
              {(c, i, { remove }) => (
                <div
                  key={i}
                  className="card px-4 py-3 mb-4"
                >
                  <button
                    className="btn btn-link close"
                    onClick={() => remove(i)}
                  >
                    <FA icon={faTimes} size="sm" />
                  </button>
                  <div className="form-row">
                    <div className="col">
                      <FormGroup
                        name={`list.${i}.header`}
                        label="Header"
                      />
                      <FormGroup
                        name={`list.${i}.subheader`}
                        label="Subheader"
                        as="textarea"
                      />
                    </div>
                    <div className="col">
                      <FormGroup
                        name={`list.${i}.attachmentBtn`}
                        label="Attachment Button"
                      />
                      <FormGroup
                        name={`list.${i}.attachment`}
                        label="Attachment"
                        as="file"
                        api={'api/site/view-slots/files'}
                      />
                    </div>
                  </div>
                </div>
              )}
            </FieldArrayIterables>
          </div>
        )}
        {(format === 'page' || format === 'collapsibles') && (
          <div className="form-group">
            <label>Collapsibles</label>
            <FieldArrayIterables
              name="collapsibles"
              push={defaultCollapsible}
            >
              {(c, i, { remove }) => (
                <div
                  key={i}
                  className="card px-4 py-3 mb-4"
                >
                  <button
                    className="btn btn-link close"
                    onClick={() => remove(i)}
                  >
                    <FA icon={faTimes} size="sm" />
                  </button>
                  <FormGroup
                    name={`collapsibles.${i}.header`}
                    label="Header"
                  />
                  <FormGroup
                    name={`collapsibles.${i}.content`}
                    label="Content"
                    as="summernote"
                    fileUploadUrl={'api/site/view-slots/files'}
                  />
                </div>
              )}
            </FieldArrayIterables>
          </div>
        )}
      </Form>
    </Formik>
  );
};

export default FormViewSlot;
